/**
 * Desfecho de cada linha da planilha, derivado dos fatos que o BFF resolve no
 * dry-run: o EAN existe no catálogo dos publishers, já está em "Meus produtos"
 * e a marca que ele tem hoje.
 */
export type ImportRowStatus =
  | 'add'
  | 'link'
  | 'move'
  | 'unchanged'
  | 'error'
  | 'unknown'

const sameBrand = (one: string | null | undefined, other: string) =>
  (one ?? '').trim().toUpperCase() === other.trim().toUpperCase()

/**
 * `unknown` enquanto o fato não vem resolvido: ausente (só o parse do arquivo)
 * ou `null` (o BFF não conseguiu confirmar). Só `false` afirma a ausência.
 */
export const resolveImportRowStatus = (
  row: AdvertiserBrandImportRow,
  hasError: boolean
): ImportRowStatus => {
  if (hasError) return 'error'

  if (row.in_publisher_catalog == null) return 'unknown'

  if (!row.in_publisher_catalog) return 'error'

  if (row.in_advertiser_products == null) return 'unknown'

  if (!row.in_advertiser_products) return 'add'

  if (!row.current_brand) return 'link'

  return sameBrand(row.current_brand, row.brand) ? 'unchanged' : 'move'
}

/** Contagem por desfecho, para o resumo acima da tabela. */
export const countImportRowStatuses = (statuses: ImportRowStatus[]) =>
  statuses.reduce<Record<ImportRowStatus, number>>(
    (acc, status) => {
      acc[status] += 1

      return acc
    },
    { add: 0, link: 0, move: 0, unchanged: 0, error: 0, unknown: 0 }
  )
